import React from 'react'
import { Card } from '@toasttab/shared/src/utils/craftUtils'
import { RestaurantCardProps } from './types.d'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import TextLink from '@toasttab/shared/src/components/molecules/TextLink/TextLink'
import Badge from '@toasttab/shared/src/components/atoms/Badge/Badge'
import ImageResolutions from '@toasttab/shared/src/components/atoms/Image/ImageResolutions'

const RestaurantCard = ({
  badgeColor,
  badgeText,
  borderColor,
  ctaLabel,
  ctaLink,
  description,
  elevation,
  heading,
  images,
  linkIcons,
  list,
  padding = '16'
}: RestaurantCardProps) => {
  return (
    <div
      className={`restaurant-card rounded-md border bg-white ${Card.borderColor(
        borderColor
      )} ${Card.elevation(elevation)}`}
      data-testid='restaurantcard'
    >
      <div
        className={`${Card.cardPadding(padding)} flex flex-col justify-between`}
      >
        <div>
          {images && (
            <ImageResolutions
              imageAlt={
                images.imageResolutions[0].desktop[0].title
                  ? images.imageResolutions[0].desktop[0].title
                  : null
              }
              borderRadius={
                images.imageResolutions[0].borderRadius
                  ? images.imageResolutions[0].borderRadius.label
                  : 'None'
              }
              images={images}
              classes='mb-8'
            />
          )}
          {heading && (
            <Typography variation='h4' as='h4' classes='mb-2'>
              {heading}
            </Typography>
          )}
          {description && (
            <Typography
              variation='default'
              as='p'
              classes='pb-4 text-secondary'
            >
              {description}
            </Typography>
          )}
          {badgeText && badgeColor && (
            <Badge text={badgeText} badgeColor={badgeColor} classes='mb-5' />
          )}
          {list && (
            <div>
              <ul className='pl-0 list-none'>
                {list.map((item: string, index: number) => {
                  return (
                    <li
                      key={index}
                      className={`font-normal text-base ${
                        list.length != index + 1 ? 'mb-2' : ''
                      } text-secondary`}
                    >
                      {item}
                    </li>
                  )
                })}
              </ul>
            </div>
          )}
        </div>
        {ctaLabel && ctaLink && (
          <div className='mt-6'>
            <TextLink
              text={ctaLabel}
              href={ctaLink}
              fontWeight={['font-semibold']}
              icon={linkIcons ? linkIcons : 'none'}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default RestaurantCard
